<script setup lang="ts">
import { onMounted } from "vue";

import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";

onMounted(() => {
  // @ts-expect-error: This is supposed to crash to test our crash reporter
  undefinedFunction();
});
</script>

<template>
  <FullPageCenteredLayout>I'am supposed to crash.</FullPageCenteredLayout>
</template>
